module.exports = __webpack_public_path__ + "static/media/keynote.b6a18f50.svg";